import styled from 'styled-components';
import type { WithSX } from '@elfsight/lib-utils';
import { applySX, isTransparentColor } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { meta } from '../../constants';
import { useLayoutGap } from '../layout';
import { useSocialFeedSettings } from '../utils';
import { TabItem } from './TabItem';
import { useTabs } from './TabsProvider';
import { TabsSlider } from './tabs-slider';

const { alias } = meta;

export function Tabs() {
  const { tabsBackgroundColor, tabsCornerRadius, displayTabs, tabElements } =
    useSocialFeedSettings();
  const { tabList, setCurrentTab } = useTabs();

  const hasBackgroundColor = !isTransparentColor(tabsBackgroundColor);
  const extraMargin = hasBackgroundColor ? 0 : 16;
  const { gap: marginBottom } = useLayoutGap();

  const display =
    displayTabs &&
    !!tabElements.length &&
    !!tabList.length &&
    alias === 'social-feed';

  if (!display) {
    return null;
  }

  return (
    <Container
      $sx={{
        margin: `0 auto ${marginBottom + extraMargin}px`,
        backgroundColor: tabsBackgroundColor,
        borderRadius: hasBackgroundColor ? tabsCornerRadius : 0
      }}
    >
      <TabsSlider>
        {tabList.map(({ id, type, name }) => (
          <TabItem
            key={id}
            id={id}
            type={type}
            name={name}
            onClick={() => setCurrentTab(id)}
          />
        ))}
      </TabsSlider>
    </Container>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'tabs',
    element: 'container'
  })
})<WithSX>`
  ${applySX};
  overflow: hidden;
  display: flex;
  justify-content: center;
`;
